/**
 * Select2 iOS Compatibility Fix
 *
 * Ensures Select2 dropdowns are touchable on iOS devices.
 * Particularly targets the Everest Forms country selector.
 *
 * @package Clemens Online
 */

document.addEventListener('DOMContentLoaded', function() {
    // Only run on iOS devices
    if (!/iPad|iPhone|iPod/.test(navigator.userAgent)) {
        return;
    }

    // Fix for Everest Forms Select2 country field
    if (typeof jQuery !== 'undefined') {
        jQuery('.evf-country-flag-selector').on('select2:opening', function() {
            const $this = jQuery(this);
            if ($this.data('select2') && $this.data('select2').dropdown.$search) {
                $this.data('select2').dropdown.$search.focus();
            }
        });

        // Additional fix: Ensure the select2 container is clickable
        jQuery(document).on('click', '.select2-selection', function() {
            if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
                jQuery(this).closest('.select2-container').prev('select').trigger('focus');
            }
        });
    }
});
